import { Checkbox, TextBox } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from "@progress/kendo-react-layout";
import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { SvgIcon } from "@progress/kendo-react-common";
import { arrowRotateCwIcon, saveIcon } from "@progress/kendo-svg-icons";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { loadingPanel } from "../../LoadingPanel";
import { Button } from "@progress/kendo-react-buttons";

export const ConfigLocatorCollector = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const [selected, setSelected] = useState<number>(0);

    const [tabList, setTabList] = useState<any>([]);
    const [newTabList, setNewTabList] = useState<any>([]);
    const [tabNameList, setTabNameList] = useState<any>([]);
    
    const [loading, setLoading] = useState(false);
    const [updated, setUpdated] = useState(false);

    const handleSelect = (e: TabStripSelectEventArguments) => {
        setSelected(e.selected);
    };

    useEffect(() => {
        getTabList();
    }, [])

    const getTabList = async () => {

        setLoading(true);

        let languageId = localStorage.getItem('languageId');

        const commonOperations = async (accessToken: any) => {
          const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

          try {
            const res = await axios.get(`${SERVER_URL}/settings/Collector`, { headers })

            const data = res.data

            let tabList:any = [];
            let tabNameList:any = [];
            let tabIdList:any = [];
            let tabDescriptionList:any = [];
            let tabValueList:any = [];
            data.data.forEach((tab: any) => {
                if(!tabNameList.includes(tab.group)){
                    tabNameList.push(tab.group)
                }
                tabList.push(tab)
                tabIdList.push({id:tab.id})
                tabDescriptionList.push(tab.description)
                tabValueList.push({value: tab.value})
            })
            setTabList(tabList)
            setTabNameList(tabNameList)

            setLoading(false);

          } catch (error: any) {
                //setError(error);
                setLoading(false);
          }
        }
        if (localStorage.getItem('accessToken') != null) {
          let accessToken = localStorage.getItem('accessToken');
          commonOperations(accessToken);
        } else {
          await instance.initialize();
          await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
            // Acquire token silent success
            let accessToken = accessTokenResponse.accessToken;
            commonOperations(accessToken)
          })
        }
    }

    const handleChange = (e:any, index:any) => {        
        let currTabList:any = newTabList != '' ? newTabList : tabList;
        const value:any = e.target.value == true ? "1" : "0";
        currTabList = currTabList.map((element:any) => {
            if(element.id == index){
                return {...element, value : value}
            }else{
                return element
            }
        });
        setNewTabList(currTabList);  
    };

    const saveGeneralsParams = async () => {

        //console.log(newTabList);
        
        setLoading(true);

        document.documentElement.style.setProperty('--overflow-y-container', 'hidden'); 
        document.documentElement.style.setProperty('--content-position-loading', 'fixed'); 
        
        const params = {
            settings: newTabList            
        }
        
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.put(`${SERVER_URL}/settings/Collector`, params, { headers })
                
                setNewTabList(newTabList);
                
                setUpdated(true);
                
                setTimeout(() => {
                    setUpdated(false);
                }, 3000);
                
                setLoading(false);
                
                document.documentElement.style.removeProperty('--overflow-y-container');
                document.documentElement.style.removeProperty('--content-position-loading');

            } catch (error: any) {
                //setError(error?.message);
                setLoading(false);
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }


    }

    const resetGeneralsParams = () => {        
        //window.location.reload();
        getTabList()
    }

    return (
        <div>
            {loading && loadingPanel}
            
            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 50,
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>
                    {updated && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setUpdated(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.locator.updated', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>
            <TabStrip selected={selected} onSelect={handleSelect} tabPosition="left" style={{background: "#F7F7F7"}}>
                {
                    tabNameList?.map((tabName:any, index:any) => {
                        let currTabList:any = newTabList != '' ? newTabList : tabList;
                        return (
                        //<TabStripTab title={localizationService.toLanguageString('configuration.locator.locator_server.advanced', 'NOT FOUND')}>
                        
                            <TabStripTab title={tabName} key={index}>
                                {   
                                    currTabList?.map((tab:any, index:any) => {
                                        if(tab.group == tabName){
                                            if(!tab.id.includes('Enabled') ){
                                                return (
                                                    //<div style={{ display:`${index > 4 ? 'flex' : 'block'}`}}>
                                                    <>
                                                        {/*<div className="k-h5" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.locator.locator_server.minimumDistance', 'NOT_FOUND')}</div>*/}
                                                        {/*<div className="k-h5" style={{ color: '#018CA5' }}>{tab.id}</div>*/}
                                                        {/*<div style={{flex: '50%'}}>*/}
                                                            <div className="" style={{ color: '#018CA5' }}>{tab.id}</div>
                                                            <TextBox
                                                                key={index}
                                                                id={tab.id}
                                                                defaultValue={tab.value}
                                                                size="small"
                                                                onChange={(event:any)=>handleChange(event, tab.id)}
                                                                title={tab.description}
                                                                placeholder={tab.description}
                                                                //placeholder={localizationService.toLanguageString('configuration.locator.locator_server.minimumDistance', 'NOT_FOUND')}
                                                            />
                                                            <br />
                                                            <br />
                                                        {/*</div>*/}
                                                    {/*</div>*/}
                                                </>
                                                )
                                            }else{
                                                return (
                                                    <>
                                                        <Checkbox
                                                            key={index}
                                                            label={tab.id}
                                                            defaultChecked={tab.value == 0 ? false : true}
                                                            onChange={(event:any)=>handleChange(event, tab.id)}
                                                        />
                                                        <br />
                                                    </>
                                                )
                                            }
                                        }
                                    })
                                }
                            </TabStripTab>
                        )
                    })
                }
            </TabStrip>

            <div className="k-listview-item row" style={{ margin: '20px 70px', alignItems: 'baseline'}}>
                {/*<Button
                    themeColor={"primary"}
                    style={{
                        marginRight: '20px',
                    }}
                    onClick={() => resetGeneralsParams()}
                >
                    <SvgIcon
                        icon={arrowRotateCwIcon}
                        style={{ color: 'white', verticalAlign: 'baseline', margin: '8px' }}
                    />
                    <span style={{ verticalAlign: 'text-bottom' }}>{localizationService.toLanguageString('configuration.locator.locator_client.reset', 'NOT_FOUND')}</span>
                </Button>
                <Button
                    title={localizationService.toLanguageString('configuration.locator.locator_client.save', 'NOT_FOUND')}                  
                    themeColor={"primary"}
                    disabled={newTabList?.length == 0 ? true : false}
                    onClick={() => saveGeneralsParams()}
                >
                    <SvgIcon
                        icon={saveIcon}
                        style={{ color: 'white', verticalAlign: 'baseline', margin: '8px' }}                        
                    />
                    <span style={{ verticalAlign: 'text-bottom' }}>{localizationService.toLanguageString('configuration.locator.locator_client.save', 'NOT_FOUND')}</span>
                </Button>*/}

                <Button
                    className="save-devices-management-button"
                    style={{
                        marginRight: '20px',
                    }}
                    themeColor={"primary"}
                    svgIcon={arrowRotateCwIcon}
                    onClick={() => resetGeneralsParams()}
                >
                    {localizationService.toLanguageString('configuration.locator.locator_client.reset', 'NOT_FOUND')}
                </Button>
                
                <Button
                    className="save-devices-management-button"
                    disabled={newTabList?.length == 0 ? true : false}
                    themeColor={"primary"}
                    svgIcon={saveIcon}
                    onClick={() => saveGeneralsParams()}
                >
                    {localizationService.toLanguageString('configuration.locator.locator_client.save', 'NOT_FOUND')}
                </Button>

            </div>
        </div>
    )
}